import React from "react";
import processBoxStyle from "./processBoxStyle";
import { Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import _map from "lodash/map";
import { getProcessConfig } from "@/src/services/serviceWorldService";
import IconCheckCircleBig from "../../../assets/icons/serviceOverview/IconCheckCircleBig";
import IconWrapper from "../../IconWrapper/IconWrapper";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import ProductBox from "@/src/components/ProductBox/ProductBox";

type InitialProcessBoxProps = {
  productClassName: AbstractCase["name"];
};

// TODO: Check if it could be merged with process box
//pretty redundant right now, but in the future the content might differ quite a bit
const InitialProcessBox = ({ productClassName }: InitialProcessBoxProps) => {
  const processConfig = getProcessConfig({ name: productClassName, leadStatus: 10, id: 0 });

  if (!processConfig) {
    return null;
  }

  return (
    <ProductBox headline={processConfig.headline}>
      <Grid container spacing={{ xs: 2, md: 3 }}>
        {_map(processConfig.steps, (step, index: number) => (
          <Grid key={index} size={{ xs: 12, md: 4 }} sx={[processBoxStyle.textBlock, step.done ? processBoxStyle.done : null]}>
            <Typography sx={{ marginBottom: "1rem" }}>
              <Stack direction={"row"} sx={{ alignItems: "center" }} spacing={1}>
                {step.done ? (
                  <IconCheckCircleBig sx={processBoxStyle.progressIcons} />
                ) : (
                  <IconWrapper icon={step.icon} alt="Step Icon" sx={processBoxStyle.progressIcons} />
                )}
                <strong>{step.headline}</strong>
              </Stack>
            </Typography>
            <Typography sx={processBoxStyle.stepText}>{step.content}</Typography>
          </Grid>
        ))}
      </Grid>
    </ProductBox>
  );
};

export default InitialProcessBox;
